import React, { useMemo, useState } from 'react';
import { connect, useIntl, useDispatch, getLocale } from 'umi';
import {
  Layout,
  Justify,
  Segment,
  Row,
  Col,
} from "tea-component";
import BreakdownContext from '@/pages/dashboard/pages/overview/components/BreakdownContext';
import CountriesContext from '@/pages/dashboard/pages/overview/components/CountriesContext';
import KeyPerformanceMetrics from '@/pages/dashboard/pages/overview/components/KeyPerformanceMetrics';
import { DATE_DIMENSION, FORM_MAP } from '@/pages/dashboard/pages/overview/_config/constant';
import useWeekRegionModel from '@/pages/dashboard/servicesModels/overview/weekRegionModel';
import useWeekMetricsModel from '@/pages/dashboard/servicesModels/overview/weekMetricsUserModel';
import useEventData from '@/pages/dashboard/servicesModels/overview/overviewEventDataModel';
import OverviewTable from '@/pages/dashboard/pages/overview/components/OverviewTable';
import EngagementRevenueMetrics from '@/pages/dashboard/pages/overview/components/EngagementRevenueMetrics/EngagementRevenueMetrics';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import { useBuriedPoint } from "@/pages/home/utils/customHook";
import WeekFilterNew from '@/pages/dashboard/filterPageComponents/overview/weekFilterNew';
import MarqueeInfo from "@/pages/dashboard/components/MarqueeInfo";

import "@/pages/dashboard/assets/scss/page/Overlay/index.scss";
import { SubTitle } from '@/pages/dashboard/components/SubTitle';

const { Content } = Layout;
const Week = (props: any) => {
  const { gameCode, explainInfo,gameConfig, timeZone } = props;
  const dispatch = useDispatch();
  const { formatMessage } = useIntl(); // 中英切换方法
  const { getLocalText } = useLocal();
  const isEN = getLocale() === 'en-US';
  const [formValue, setFormValue] = useState<any>({
    filterValue: null,
    newFilter: true,
    timeType: 'Week',
    [FORM_MAP.RANGE_TIME_DIFF]: true
  });
  const { rangeTime } = formValue?.filterValue ?? [];
  const [filterLoading, setFilterLoading] = useState(true);
  const [regionDataType, setRegionDataType] = useState('country');

  const regionData = useWeekRegionModel(props, formValue, dispatch, filterLoading, regionDataType);
  const metricsData = useWeekMetricsModel(props, formValue, dispatch, filterLoading, regionDataType);
  const [eventData, loading] = useEventData(gameCode, formValue, filterLoading);

  const COUNTRY_AREA_ZONE = [
    { text: formatMessage({ id: 'overview_Country' }), value: 'country' },
    { text: formatMessage({ id: 'overview_Region' }), value: 'region' },
    { text: formatMessage({ id: 'overview_Zone' }), value: 'zone' },
    { text: formatMessage({ id: 'common_Channel' }), value: 'channel' },
    { text: formatMessage({ id: 'overview_area_tab_os' }), value: 'os' },
  ];

  // 打点
  const logObj = {
    pageId: '200201',
    pageName: 'overviewWeekly',
    extInfo: 'overviewWeekly',
    pagePath: '/overview/weekly',
    uid: gameCode,
    typeId: 'dashboard_pc_v2',
  };

  useBuriedPoint(logObj);

  const handleConfirm = (value: any) => {
    setFormValue({
      ...formValue,
      ...value
    });
  };


  // Country/Region/Zone 切换时的处理方法
  const changeBreakdown = useMemo(
    () => ((val: any) => {
      setRegionDataType(val);
    }
    ), [formValue, gameCode, filterLoading]);

  const handleInit = (value: any) => {
    setFormValue({
      ...formValue,
      ...value,
    });
    setFilterLoading(false);
  };

  return (
    <Content className='dbd-scroll-body'>
      <Content.Header
        title={<div className='page-title'>{formatMessage({ id: 'overview_weekly_Weekly' })}</div>}
        subtitle={<SubTitle/>}
      ></Content.Header>
      <Content.Body full>
        <MarqueeInfo pagePath={"/overview/weekly"} />
        <WeekFilterNew
          openSticky={true}
          filterConfirm={handleConfirm}
          timeZone={timeZone}
          filterReset={handleConfirm}
          buttonLogConfig={{ pageId: '200201', confirmButtonId: '200201001', resetButtonId: '200201002' }}
          filterLoading={filterLoading}
          setFilterLoading={setFilterLoading}
          filterInit={handleInit}
        />
        <Justify
          className="overlay-margin"
          left={
            <div className='overlay-title'>{getLocalText('overview_Key_Performance_Metrics')}</div>
          }
          right={
            <div className='overlay-time'>{rangeTime?.length > 1 ? `${rangeTime[0]} ~ ${rangeTime[1]}` : ''}</div>
          }
        />
        <KeyPerformanceMetrics
          parentProps={props}
          formValue={formValue}
          dispatch={dispatch}
          filterLoading={filterLoading}
          gameCode={gameCode}
          explainInfo={explainInfo}
          dateDimension={DATE_DIMENSION.WEEK}
        />
        <Row className="margin-t-10">
          <Col><EngagementRevenueMetrics renderIndex={0} gameCode={gameCode} eventData={eventData}  loading={loading} filterLoading={filterLoading} formValue={formValue} explainInfo={explainInfo} type={DATE_DIMENSION.WEEK} /></Col>
          <Col><EngagementRevenueMetrics renderIndex={1} gameCode={gameCode} eventData={eventData}  loading={loading} filterLoading={filterLoading} formValue={formValue} explainInfo={explainInfo} type={DATE_DIMENSION.WEEK} /></Col>
        </Row>
        <Row className="margin-t-10">
          <Col>
            <OverviewTable
              filterValue={formValue}
              gameConfig={gameConfig}
              tableType='week'
              filterLoading={filterLoading}
              gameCode={gameCode}
              explainInfo={explainInfo}
              logObj={logObj}
            />
          </Col>
        </Row>
        <Row className="margin-t-10">
          <Col><BreakdownContext componetIndex={0} data={metricsData} gameCode={gameCode} type={DATE_DIMENSION.WEEK} formValue={formValue} /></Col>
          <Col><BreakdownContext componetIndex={1} data={metricsData} gameCode={gameCode} type={DATE_DIMENSION.WEEK} formValue={formValue} /></Col>
        </Row>
        <Justify className="overlay-margin-breakdown" left={
          <Segment
            className={isEN ? "segment-light" : "segment-light segment-light-china"}
            options={COUNTRY_AREA_ZONE}
            defaultValue={'country'}
            onChange={changeBreakdown}
          />
        } />
        {/* 只有三个，没必要map */}
        <Row>
          <Col className='margin-b-10'>
            <CountriesContext
              index={0}
              regionDataType={regionDataType}
              data={regionData}
              formValue={formValue}
              activeUserType="WAU"
              type="DAU"
              gameCode={gameCode}
            />
          </Col>
        </Row>
        <Row>
          <Col className='margin-b-10'>
            <CountriesContext
              index={1}
              regionDataType={regionDataType}
              data={regionData}
              formValue={formValue}
              activeUserType="WAU"
              type="Revenue"
              gameCode={gameCode}
            />
          </Col>
        </Row>

        <Row>
          <Col className='margin-b-10'>
            <CountriesContext
              index={2}
              regionDataType={regionDataType}
              data={regionData}
              formValue={formValue}
              activeUserType="WAU"
              type="New"
              gameCode={gameCode}
            />
          </Col>
        </Row>
      </Content.Body>
    </Content >
  );
};


export default connect((state: any) => ({
  serviceData: state.overview?.data,
  gameCode: state.dashboard?.currentGame?.game_code,
  explainInfo: state.dashboard?.explainInfo,
  gameConfig: state?.dashboardSetting?.gameConfig
}))(Week);
